import * as api from '../api';
import { CallApiArgs } from '../api.types';

const withDefaults = (args: CallApiArgs = {}) => ({
  data: args?.data ?? {},
  options: args?.options ?? {},
});

export const createNotification = (args: CallApiArgs) => {
  return api.callPost('/manager/notifications', withDefaults(args));
};

export const fetchNotifications = (args: CallApiArgs = {}) => {
  return api.callGet('/manager/notifications', withDefaults(args));
};

export const updateNotification = (args: CallApiArgs) => {
  const { data = {}, options } = args || {};
  const { id, ...rest } = data || {};
  if (!id) {
    const error: any = new Error('Notification id is required to update a notification.');
    error.statusCode = 400;
    throw error;
  }
  return api.callPatch(`/manager/notifications/${id}`, {
    data: rest,
    options: options ?? {},
  });
};

export const updateNotificationTracking = (args: CallApiArgs) => {
  const { data = {}, options } = args || {};
  const { notificationId, trackingId, ...rest } = data || {};
  if (!notificationId || !trackingId) {
    throw new Error('notificationId and trackingId are required');
  }
  return api.callPatch(`/manager/notifications/${notificationId}/tracking/${trackingId}`, {
    data: rest,
    options: options ?? {},
  });
};

export const uploadNotificationMedia = (args: CallApiArgs) => {
  const { data, options } = args || {};
  if (!data) {
    throw new Error('Media upload requires form data.');
  }
  return api.callPostWithFormData('/manager/notifications/media', {
    data,
    options: options ?? {},
  });
};
